import React, { useEffect, useState } from 'react'
import MySelect from '../../../../UI/form/MySelect'
import { useDispatch, useSelector } from 'react-redux'
import { editSupplyBillsItemsFiltersAgreeDeputyDirectorSupply } from '../../../../../store/supplyBillSlice'

const SupplyBillItemsAllFilterAgreeDeputyDirectorSupply = () => {

	const agree = useSelector(state => state.supplyBill.supplyBillsItemsAll.filters.agreeDeputyDirectorSupply)
	const dispatch = useDispatch()

  	const [value, setValue] = useState(agree)
  	const [validSelect, setValidSelect] = useState(false)
	const [options, setOptions] = useState([
		{
			id: 'yes',
			name: 'Так'
		},
		{
			id: 'no',
			name: 'Ні'
		},
		{
			id: 'other',
			name: 'Немає'
		},
		{
			id: 'all',
			name: 'Всі'
		},
	])

  return (
    <MySelect
        value={value}
        label="Погодження замдиректора"
        labelId="select__filterAgreeDeputyDerictorSupply-label"
        id='select__filterAgreeDeputyDerictorSupply'
        onChange = {e => {
            setValue(e)
			dispatch(editSupplyBillsItemsFiltersAgreeDeputyDirectorSupply(e))
			// setEvent({...event, categoryId: e})
		}}
        nameField='Погодження замдиректора'
        // sx={{width: '200px'}}
        options={
			options && options.length > 0 ? 
				options.map(option => {
            		return {id: option.id, name: option.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default SupplyBillItemsAllFilterAgreeDeputyDirectorSupply